export default {
    methods: {
        clone: function(obj) {

            if (Array.isArray(obj)) {

                return obj.map(m => this.clone(m))
            }
            else if (obj instanceof File) {

                return new File([obj], obj.name)
            }
            else if (obj instanceof Date) {

                return new Date(obj.getTime())
            }
            else if (obj === Object(obj) && typeof obj !== 'function') {

                const newObj = {}

                Object.keys(obj).forEach(k => {

                    newObj[k] = this.clone(obj[k])
                })

                return newObj
            }

            return obj;
        },
        filterNotNull: function(obj) {

            if (Array.isArray(obj)) {

                return obj.map(m => this.filterNotNull(m))
            }
            else if (obj === Object(obj) && typeof obj !== 'function') {

                const newObj = {}

                Object.keys(obj).forEach(k => {

                    if (obj[k] !== null && obj[k] !== undefined) {

                        newObj[k] = this.filterNotNull(obj[k])
                    }
                })

                return newObj
            }

            return obj;
        },
        objectToFormData(obj, form, namespace) {

            let fd = form || new FormData()
            let formKey

            for(let property in obj) {

              if (Object.prototype.hasOwnProperty.call(obj, property)) {

                    if (namespace) {

                        formKey = namespace + '[' + property + ']'
                    }
                    else {

                        formKey = property
                    }

                    if (obj[property] === null || obj[property] === undefined) {

                        fd.append(formKey, '')
                    }
                    else if (obj[property] instanceof Date) {

                        fd.append(formKey, obj[property].toISOString())
                    }
                    else if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {

                        this.objectToFormData(obj[property], fd, formKey)
                    }
                    else if (typeof obj[property] === 'boolean') {

                        fd.append(formKey, obj[property] ? 1 : 0)
                    }
                    else {

                        fd.append(formKey, obj[property])
                    }
                }
            }

            return fd;
        },
        getSafely(callback, fallbackResult = null) {

            let result

            try {

                result = callback()
            }
            catch {

                result = fallbackResult
            }

            return result
        }
    }
}